import { PaldeskModuleFederation } from '@paldesk/module-federation/core';
import { environment } from './environments/environment';

PaldeskModuleFederation.replaceEnvironmentFile(
  environment.production
    ? 'assets/config/config.json'
    : 'assets/config/config.development.json',
  environment,
)
  .then(() =>
    PaldeskModuleFederation.prepareHost({
      hostName: 'business-partner-management',
      env: environment.environment,
      remotes: environment.remotes,
    }),
  )
  .then(() => import('./bootstrap'));
